import { z } from "zod";

/**
 * A model eligible as a HALO run's analysis or summarization model, as
 * surfaced by `modelService.listHaloModels` / `listHaloSummarizationModels`.
 * Mirrors `HaloModelSummary` from `@inference-net/model-service`.
 */
export const haloModelSummarySchema = z.object({
  id: z.string(),
  canonicalAlias: z.string(),
  name: z.string(),
  huggingFaceId: z.string().nullable(),
  ownerTeamId: z.string(),
});

/**
 * A HALO conversation row, scoped to a team. Mirrors the
 * `HaloConversationsTable` Drizzle select (`HaloConversationSchemaType`):
 * `createdAt`/`updatedAt` are raw `Date` objects (Postgres `mode: "date"`),
 * `title`/`latestRunId` are nullable.
 */
export const haloConversationSchema = z.object({
  id: z.string(),
  teamId: z.string(),
  projectId: z.string(),
  title: z.string().nullable(),
  latestRunId: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
